import React from 'react';
import Fab from '@material-ui/core/Fab';

import { withStyles } from '@material-ui/core';

const styles = (theme) => ({
    fab: {
      marginTop: -28,
      position: 'absolute',
      right: 204,
      zIndex: 1190,
      backgroundColor: '#F44336',
      '&::before': {
        content: '""',
        display: 'block',
        width: '20px',
        height: '2px',
        backgroundColor: '#F44336',
        position: 'absolute',
        top: '50%',
        left: '-30px', // Positioning the hamburger icon outside to the left
        transform: 'translateY(-50%)',
      },
    },
  });

const CustomFab = ({ classes, readOnly, onClick, children }) => {
  return (
    <Fab
      disabled={readOnly}
      className={classes.fab}
      onClick={onClick}
    >
      {children}
    </Fab>
  );
};

export default withStyles(styles)(CustomFab);